import modalTemplate from './view.html';
import { UsbAttackModalController } from './controller';

import { USB_ATTACK_MODAL_CONTROLLER } from '../../const';

class UsbAttackModal {
    constructor($uibModal) {
        'ngInject';
        this.$uibModal = $uibModal;
        this.modalInstance = null;
    }

    $onInit = () => {
        this.$uibModal;
    };

    open = (attackId = null, copyId = null) => {
        this.modalInstance = this.$uibModal.open({
            template: modalTemplate,
            bindToController: true,
            controller: USB_ATTACK_MODAL_CONTROLLER,
            controllerAs: '$',
            size: 'lg',
            resolve: {
                attackId: attackId,
                copyId: copyId,
            },
            backdrop: 'static',
            keyboard: false,
        });

        return this.modalInstance.result;
    };
}

export {
    UsbAttackModal,
    UsbAttackModalController,
};
